// src/components/ISO.js
import React from 'react';

const ISO = () => {
  return (
    <div className="iso-container">
      <h2>ISO Certification</h2>
      <p>
        Sumatidevi Tompe Institute is an ISO [Your ISO Standard, e.g., 9001:2015] certified institution. This certification reflects our commitment to maintaining a high-quality management system for our educational processes and services.
      </p>
     
    </div>
  );
};

export default ISO;